import React, { useState, useEffect } from "react";
import {
  fetchEvents,
  handleUpdateEvents,
  locationMasters,
} from "../../redux/actions/grievanceActions1";
import { useDispatch, useSelector } from "react-redux";

const UpdateEvent = ({ onClose, show, eventDetails }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(locationMasters());
  }, [dispatch]);
  const [title, setTitle] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [eventFromTime, setEventFromTime] = useState("");
  const [eventToTime, setEventToTime] = useState("");
  const [location, setLocation] = useState("");
  const [eventDesc, setEventDesc] = useState("");
  const [importantGuests, setImportantGuests] = useState("");
  const [eventUrl, setEventUrl] = useState("");
  const { locationMaster } = useSelector((state) => state.grievances);

  // Error state
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  //   const formatDateForInput = (dateString) => {
  //     if (!dateString) return "";
  //     try {
  //       const [datePart] = dateString.split(" ");
  //       const [day, month, year] = datePart.split("-");
  //       return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  //     } catch (error) {
  //       console.error("Error formatting date:", error);
  //       return "";
  //     }
  //   };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    try {
      const [datePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("-");

      // Handle 2-digit year format (YY) and convert to full year
      let fullYear = year;
      if (year.length === 2) {
        const currentYear = new Date().getFullYear();
        const currentCentury = Math.floor(currentYear / 100) * 100;
        fullYear = currentCentury + parseInt(year);

        // If the resulting year is more than 50 years in the future, assume previous century
        if (fullYear - currentYear > 50) {
          fullYear -= 100;
        }
      }

      return `${fullYear}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };
  const formatTimeForInput = (timeString) => {
    if (!timeString) return "";
    return timeString.substring(0, 5);
  };

  //   // Populate form when eventDetails is provided
  //   useEffect(() => {
  //     if (eventDetails && show) {
  //       setTitle(eventDetails.title || "");
  //       setEventDate(formatDateForInput(eventDetails.event_date));
  //       setEventFromTime(formatTimeForInput(eventDetails.event_from_time));
  //       setEventToTime(formatTimeForInput(eventDetails.event_to_time));
  //       setLocation(eventDetails.location || "");
  //       setEventDesc(eventDetails.event_desc || "");
  //       setImportantGuests(eventDetails.important_guests || "");
  //       setEventUrl(eventDetails.event_url || "");
  //       setErrors({});
  //     }
  //   }, [eventDetails, show ,locationMaster]);

  useEffect(() => {
    if (eventDetails && locationMaster) {
      setTitle(eventDetails.title || "");
      setEventDate(formatDateForInput(eventDetails.event_date));
      setEventFromTime(formatTimeForInput(eventDetails.event_from_time));
      setEventToTime(formatTimeForInput(eventDetails.event_to_time));

      // Set location based on location_name from eventDetails
      // if (eventDetails.location_name) {
      //   setLocation(eventDetails.location_name);
      // } else if (eventDetails.location_id) {
      //   // Fallback: find location name by location_id
      //   const foundLocation = locationMaster.find(
      //     (loc) => loc.location_id == eventDetails.location_id
      //   );
      //   setLocation(foundLocation ? foundLocation.location_name : "");
      // } else {
      //   setLocation(eventDetails.location || "");
      // }

      const foundLocation = locationMaster.find(
        (loc) => loc?.location_id == eventDetails?.location_id
      );
      setLocation( foundLocation?.location_id );
      console.log(foundLocation);
      setEventDesc(eventDetails.event_desc || "");
      setImportantGuests(eventDetails.important_guests || "");
      setEventUrl(eventDetails.event_url || "");
      setErrors({});
    }
  }, [eventDetails, show, locationMaster]);

  // Validation function
  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) newErrors.title = "Event title is required";
    if (!eventDate) newErrors.eventDate = "Event date is required";
    if (!eventFromTime) newErrors.eventFromTime = "Start time is required";
    if (!eventToTime) newErrors.eventToTime = "End time is required";
    if (!location.trim()) newErrors.location = "Location is required";
    if (!eventDesc.trim())
      newErrors.eventDesc = "Event description is required";

    // Validate time logic
    if (eventFromTime && eventToTime && eventFromTime >= eventToTime) {
      newErrors.eventToTime = "End time must be after start time";
    }

    // Validate date (allow past dates for updates, but warn user)
    if (eventDate) {
      const selectedDate = new Date(eventDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        // For updates, we'll allow past dates but could add a warning
        console.warn("Event date is in the past");
      }
    }

    // Validate URL format if provided
    if (eventUrl && eventUrl.trim()) {
      const urlPattern =
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
      if (!urlPattern.test(eventUrl.trim())) {
        newErrors.eventUrl = "Please enter a valid URL";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdateEvent = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const updateEventData = {
        addInfo: {
          event_id: eventDetails.event_id,
          title: title.trim(),
          event_date: eventDate,
          event_from_time: eventFromTime + ":00",
          event_to_time: eventToTime + ":00",
          location: location,
          event_desc: eventDesc.trim(),
          important_guests: importantGuests.trim() || "",
          event_url: eventUrl.trim() || "",
        },
      };

      console.log("Update Event Data:", updateEventData);

      const res = await dispatch(handleUpdateEvents(updateEventData));

      if (res.rCode === 0) {
        alert(res.rMessage || "Event updated successfully!");
        onClose();
        await dispatch(fetchEvents());
      } else {
        alert(res?.rMessage || "Error updating event!");
      }
    } catch (error) {
      console.error("Error updating event:", error);
      alert("Error updating event. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setTitle("");
    setEventDate("");
    setEventFromTime("");
    setEventToTime("");
    setLocation("");
    setEventDesc("");
    setImportantGuests("");
    setEventUrl("");
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="UpdateEventModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div style={{ backgroundColor: "#fff" }} className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title font-size-16"
              id="updateEvent-exampleModalLabel"
            >
              Update Event
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            {/* Event ID Display */}
            {/* {eventDetails?.event_id && (
              <div className="mb-3">
                <small className="text-muted">
                  Event ID: <strong>{eventDetails.event_id}</strong>
                </small>
              </div>
            )} */}

            {/* Event Title */}
            <div className="mb-3">
              <label htmlFor="event-title" className="form-label">
                Event Title <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.title ? "is-invalid" : ""}`}
                id="event-title"
                placeholder="Enter event title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              {errors.title && (
                <div className="invalid-feedback">{errors.title}</div>
              )}
            </div>

            {/* Event Date */}
            <div className="mb-3">
              <label htmlFor="event-date" className="form-label">
                Event Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className={`form-control ${
                  errors.eventDate ? "is-invalid" : ""
                }`}
                id="event-date"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
              />
              {errors.eventDate && (
                <div className="invalid-feedback">{errors.eventDate}</div>
              )}
            </div>

            {/* Time Fields */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="event-from-time" className="form-label">
                  Start Time <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className={`form-control ${
                    errors.eventFromTime ? "is-invalid" : ""
                  }`}
                  id="event-from-time"
                  value={eventFromTime}
                  onChange={(e) => setEventFromTime(e.target.value)}
                />
                {errors.eventFromTime && (
                  <div className="invalid-feedback">{errors.eventFromTime}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="event-to-time" className="form-label">
                  End Time <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className={`form-control ${
                    errors.eventToTime ? "is-invalid" : ""
                  }`}
                  id="event-to-time"
                  value={eventToTime}
                  onChange={(e) => setEventToTime(e.target.value)}
                />
                {errors.eventToTime && (
                  <div className="invalid-feedback">{errors.eventToTime}</div>
                )}
              </div>
            </div>

            {/* Location */}
            {/* <div className="mb-3">
              <label htmlFor="event-location" className="form-label">
                Location <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  errors.location ? "is-invalid" : ""
                }`}
                id="event-location"
                placeholder="Enter event location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
              {errors.location && (
                <div className="invalid-feedback">{errors.location}</div>
              )}
            </div> */}
            <div className="mb-3">
              <label htmlFor="event-location" className="form-label">
                Location <span className="text-danger">*</span>
              </label>
              <select
                className={`form-control ${
                  errors.location ? "is-invalid" : ""
                }`}
                id="event-location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">Select Location</option>
                {locationMaster && locationMaster.length > 0 ? (
                  locationMaster
                    .filter((loc) => loc.location_name !== "Select Location") // Filter out default option if it exists
                    .map((loc) => (
                      <option key={loc.location_id} value={loc.location_id}>
                        {loc.location_name}
                      </option>
                    ))
                ) : (
                  <option value="" disabled>
                    Loading locations...
                  </option>
                )}
              </select>
              {errors.location && (
                <div className="invalid-feedback">{errors.location}</div>
              )}
            </div>

            {/* Event Description */}
            <div className="mb-3">
              <label htmlFor="event-desc" className="form-label">
                Event Description <span className="text-danger">*</span>
              </label>
              <textarea
                className={`form-control ${
                  errors.eventDesc ? "is-invalid" : ""
                }`}
                id="event-desc"
                rows="3"
                placeholder="Enter event description"
                value={eventDesc}
                onChange={(e) => setEventDesc(e.target.value)}
              ></textarea>
              {errors.eventDesc && (
                <div className="invalid-feedback">{errors.eventDesc}</div>
              )}
            </div>

            {/* Important Guests */}
            <div className="mb-3">
              <label htmlFor="important-guests" className="form-label">
                Important Guests
              </label>
              <textarea
                className="form-control"
                id="important-guests"
                rows="2"
                placeholder="Enter important guests (optional)"
                value={importantGuests}
                onChange={(e) => setImportantGuests(e.target.value)}
              ></textarea>
            </div>

            {/* Event URL */}
            <div className="mb-3">
              <label htmlFor="event-url" className="form-label">
                Event URL
              </label>
              <input
                type="url"
                className={`form-control ${
                  errors.eventUrl ? "is-invalid" : ""
                }`}
                id="event-url"
                placeholder="https://example.com/event"
                value={eventUrl}
                onChange={(e) => setEventUrl(e.target.value)}
              />
              {errors.eventUrl && (
                <div className="invalid-feedback">{errors.eventUrl}</div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleUpdateEvent}
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                "Update Event"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateEvent;
